import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const AcceptedPharmacies = () => {
  const { t } = useTranslation();
  return (
    <div className="pharmacyNationwideWrap">
      <h2 className="title">
        {t('Accepted at')}&nbsp;
        <span className="pinkNumber">{t('35,000+')}</span>&nbsp;
        {t('pharmacies')}
        <span className="desktop-only">
          &nbsp;
          {t('nationwide')}
        </span>
      </h2>
      <div className="cardImg">
        <LazyLoadImage
          src="/content/images/signup/single-care-card-horizontal.png"
          width="331"
          height="208"
          alt=""
        />
      </div>
      <div className="imageWrapper">
        <div className="columnOne">
          <LazyLoadImage
            src="/content/images/apps/grey/costco.svg"
            height="34"
            width="121"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/cvs-pharmacy.svg"
            height="26"
            width="223"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/kroger.svg"
            height="54"
            width="99"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/publix.svg"
            height="30"
            width="142"
            alt=""
          />
        </div>
        <div className="columnTwo">
          <LazyLoadImage
            src="/content/images/apps/grey/rite-aid.svg"
            height="38"
            width="83"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/safeway.svg"
            height="33"
            width="176"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/walgreens.svg"
            height="39"
            width="176"
            alt=""
          />
          <LazyLoadImage
            src="/content/images/apps/grey/walmart.svg"
            height="40"
            width="178"
            alt=""
          />
        </div>
      </div>
      <p className="note">
        {t('We work directly with pharmacies to negotiate')}
        <span className="pinkText">&nbsp;{t('up to 80% off')} </span>
        {t('prescription prices.')}
      </p>
    </div>
  );
};

export default AcceptedPharmacies;
